import { kapitolColors } from "./kapitol";

const breakpoints = ["576px", "767.98px", "991.98px", "1260px"];

breakpoints.sm = breakpoints[0];
breakpoints.md = breakpoints[1];
breakpoints.lg = breakpoints[2];
breakpoints.xl = breakpoints[3];

const colors = {
  white: {
    100: "#FFF",
    70: "rgba(255, 255, 255, 0.7)",
    60: "rgba(255, 255, 255, 0.6)",
    50: "rgba(255, 255, 255, 0.5)",
    15: "rgba(255, 255, 255, 0.15)",
  },
  black: {
    100: "#000",
    80: "rgba(0, 0, 0, 0.8)",
    60: "rgba(0, 0, 0, 0.6)",
    50: "rgba(0, 0, 0, 0.5)",
    40: "rgba(0, 0, 0, 0.4)",
  },
  bodyText: kapitolColors.text,
  textGrey: "#515151",
  cta: kapitolColors.cta,
  link: kapitolColors.darkGreen,
  linkSecondary: kapitolColors.titaniumGrey,
  headlines: kapitolColors.blue,
  headlinesSecondary: kapitolColors.skyGrey,
  negative: kapitolColors.lightBlue50,
  panelPrimary: kapitolColors.lightBlue,
  panelSecondary: kapitolColors.skyGrey20,
  panelDark: kapitolColors.blue,
  red: "#dc0000",
  titaniumGrey: kapitolColors.titaniumGrey,

  storyBlock: {
    background: kapitolColors.skyGrey20,
  },
  lastBreadcrumb: kapitolColors.skyGrey,
  forms: {
    border: kapitolColors.titaniumGrey20,
    active: kapitolColors.darkGreen,
    radio: {
      unchecked: kapitolColors.skyGrey,
      checked: kapitolColors.darkGreen,
    },
  },
  whyAgent: {
    line: kapitolColors.darkGreen40,
    text: kapitolColors.lightBlue,
  },
  footer: {
    bg: {
      top: kapitolColors.blue,
      bottom: "#003d50",
    },
    link: kapitolColors.darkGreen40,
    mail: kapitolColors.cta,
    heading: kapitolColors.lightBlue50,
  },
  header: {
    light: {
      link: kapitolColors.darkGreen,
    },
    dark: {
      bg: kapitolColors.blue,
      link: kapitolColors.blue,
    },
    grey: {
      bg: kapitolColors.skyGrey20,
      link: kapitolColors.darkGreen,
    },
    menuIconDark: kapitolColors.nightBlue,
  },
  gradient: {
    dark: kapitolColors.nightBlue,
    light: kapitolColors.darkGreen,
    titanium: kapitolColors.titaniumGrey20,
    gray: kapitolColors.skyGrey20,
  },
  carInsurance: {
    panel: kapitolColors.insuranceLightBlue,
    stepsText: kapitolColors.nightBlue,
    stepsBg: kapitolColors.insuranceBlue,
  },
  gold: {
    headlines: kapitolColors.gold,
    border: kapitolColors.gold,
    cta: kapitolColors.goldCta,
  },
  real: {
    headlines: kapitolColors.realBlue,
    border: kapitolColors.cta,
  },
};

const sizes = {
  mobileWidth: "calc(100% - 30px)",
  container: "1230px",
};

const times = {
  transition: "300ms",
};

const space = ["0", "4px", "8px", "16px", "32px", "64px", "128px", "256px", "512px"];
space.mobileSpacer = "44px";

const fontSizes = ["12px", "14px", "16px", "20px", "24px", "32px", "40px", "50px", "64px", "96px", "128px"];

const lineHeights = [1, 1.185, 1.25, 1.5, 2];
lineHeights.heading = "64px";

const fontWeights = {
  extraLight: 200,
  light: 300,
  regular: 400,
  semiBold: 600,
  black: 900,
};

const letterSpacings = {
  normal: "normal",
  caps: "-0.02em",
  label: "-0.003em",
};

const radii = ["4px", "6px"];

const shadows = {
  one: "3px 5px 15px rgba(101, 124, 136, 0.5)",
  two: "3px 5px 15px rgba(101, 124, 136, 0.9)",
};

const borders = {
  story: "1px solid #CBD0D2",
  none: "none",
};

const fonts = {
  workSans: "'Work Sans', Arial",
};

export const theme = {
  name: "Default",
  breakpoints,
  fonts,
  colors,
  sizes,
  space,
  fontSizes,
  lineHeights,
  fontWeights,
  letterSpacings,
  radii,
  times,
  shadows,
  borders,
};
